module.exports = __webpack_public_path__ + "static/media/1021528.413b2d8b.jpg";